import { mapMutations, mapGetters } from 'vuex'
import { parseCookies } from '@/helper'

export default {
  data () {
    return {
      ws: null,

      interval: 10000,
      round: 1,

      checkPingChallengeInterval: null,
      reconnectChallengeInterval: null
    }
  },
  computed: {
    ...mapGetters('config', ['getIsOffline'])
  },
  created () {
    this.setIsOffline(false)
    // this.initConnection()
  },
  // beforeDestroy () {
  //   this.reinitConnection()
  // },
  methods: {
    ...mapMutations('config', ['setIsOffline']),
    initConnection () {
      const wsPath = process.env.NODE_ENV === 'production'
        ? 'wss://localhost:3001/ws'
        : 'ws://localhost:3001/ws'

      this.ws = new WebSocket(wsPath)

      this.initHandlers()
    },
    initHandlers () {
      if (!this.ws) {
        return
      }

      this.ws.onopen = this.handlerOnopen
      this.ws.onmessage = this.handlerOnmessage
      this.ws.onClose = this.handlerOnclose
      this.ws.onerror = this.handlerOnerror
    },
    handlerOnopen () {
      console.info('WS connect - OPENED')

      this.$notify({
        type: 'success',
        title: 'Вы в онлайне!',
        text: 'Связь с сервером установлена!',
        clean: false,
        duration: 3000
      })

      this.setIsOffline(false)
      this.sendPingMessage()
      this.startCheckPingChallenge()

      if (this.reconnectChallengeInterval) {
        clearInterval(this.reconnectChallengeInterval)
      }
    },
    handlerOnmessage (event) {
      const { type } = JSON.parse(event.data)

      if (type === 'pong') {
        this.sendPingMessage()
      }
    },
    handlerOnclose () {
      console.info('WS connect - CLOSED')

      this.$notify({
        type: 'error',
        title: 'Вы в офлайне!',
        text: 'Связь с сервером потеряна!',
        clean: false,
        duration: 3000
      })

      this.setIsOffline(true)
      this.clearWsData()
      this.startReconnectChallenge()
    },
    handlerOnerror () {
      console.info('WS connect - ERROR')

      if (this.getIsOffline && this.reconnectChallengeInterval) {
        return
      }

      this.$notify({
        type: 'error',
        title: 'Вы в офлайне!',
        text: 'Связь с сервером потеряна!',
        clean: false,
        duration: 3000
      })

      this.setIsOffline(true)
      this.clearWsData()
      this.startReconnectChallenge()
    },
    sendPingMessage () {
      const shopId = parseCookies()?.shopId || ''

      this.lastTime = Date.now()
      this.ws.send(JSON.stringify({ type: 'ping', shopId }))
    },
    startCheckPingChallenge () {
      this.checkPingChallengeInterval = setInterval(() => {
        const passedSeconds = Date.now() - this.lastTime

        if (passedSeconds >= 6000) {
          this.$notify({
            type: 'error',
            title: 'Вы в офлайне!',
            text: 'Связь с сервером потеряна!',
            clean: false,
            duration: 3000
          })

          this.clearWsData()
          this.setIsOffline(true)
          this.startReconnectChallenge()
        }
      }, 5000)
    },
    startReconnectChallenge () {
      if (this.reconnectChallengeInterval) {
        return
      }

      let counter = 0

      this.reconnectChallengeInterval = setInterval(() => {
        this.$notify({
          type: 'warning',
          title: 'Попытка подключения к серверу!',
          text: `Раунд ${this.round}. Попытка ${counter}`,
          clean: false,
          duration: 3000
        })

        this.initConnection(false)

        if (this.round === 1 && counter >= 4) {
          clearInterval(this.reconnectChallengeInterval)
          this.interval = 60000
          this.round = 2

          this.startReconnectChallenge()
        }

        if (this.round === 2 && counter >= 8) {
          clearInterval(this.reconnectChallengeInterval)
          this.interval = 120000
          this.round = 3

          this.startReconnectChallenge(120000, 3)
        }

        if (this.round === 3 && counter >= 0) {
          clearInterval(this.reconnectChallengeInterval)
          this.interval = 10000
          this.round = 1

          this.$notify({
            type: 'error',
            title: 'Соединение с сервером установить не удалось!',
            text: 'Прошло 3 раунда, попытки подключения не удались. Обратитесь к администратору!',
            clean: false,
            duration: 5000
          })
        }

        counter += 1
      }, this.interval)
    },
    clearWsData () {
      if (this.checkPingChallengeInterval) {
        clearInterval(this.checkPingChallengeInterval)
      }

      if (this.reconnectChallengeInterval) {
        clearInterval(this.reconnectChallengeInterval)
      }

      this.lastTime = 0
    },
    reinitConnection () {
      if (this.ws.readyState !== 4) {
        this.clearWsData()
        this.ws.close()
      }
    }
  }
}